import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight, Droplets } from "lucide-react";

export const QuotePopup = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 5000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => setOpen(false);

  const go = () => {
    dismiss();
    navigate("/quote");
  };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[55]"
            data-testid="quote-popup-scrim"
            onClick={dismiss}
          />

          <motion.div
            role="dialog"
            aria-modal="true"
            aria-labelledby="gutter-popup-title"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", stiffness: 240, damping: 30 }}
            data-testid="gutter-popup"
            className="fixed bottom-0 inset-x-0 z-[60] bg-[#0B1726] border-t-2 border-[#E6B445] rounded-t-2xl shadow-[0_-20px_60px_rgba(230,180,69,0.35)]"
          >
            <div className="flex justify-center pt-3 pb-1">
              <span className="w-12 h-1.5 rounded-full bg-slate-700" />
            </div>

            <button
              onClick={dismiss}
              data-testid="gutter-popup-close"
              aria-label="Close popup"
              className="absolute top-3 right-3 w-9 h-9 rounded-full bg-[#142238] border border-slate-700 text-slate-300 hover:text-white hover:border-slate-500 flex items-center justify-center transition-colors"
            >
              <X className="w-4 h-4" />
            </button>

            <div className="max-w-3xl mx-auto px-5 sm:px-8 pb-8 sm:pb-10 pt-3 text-center sm:text-left">
              <div className="inline-flex items-center gap-2 mb-3">
                <span className="h-px w-8 bg-[#E6B445]" />
                <span className="font-heading text-[10px] sm:text-xs font-bold tracking-[0.3em] uppercase text-[#E6B445]">
                  Limited Time Offer
                </span>
              </div>

              <h2
                id="gutter-popup-title"
                className="font-heading text-3xl sm:text-4xl font-black uppercase tracking-tight text-white leading-[1.05]"
              >
                Need gutter cleaning?{" "}
                <span className="text-[#E6B445]">Save 15%.</span>
              </h2>
              <p className="mt-2 text-slate-400 text-sm sm:text-base max-w-lg">
                Book your gutter cleaning today and take <span className="text-white font-semibold">15% off</span>. Mention code{" "}
                <span className="font-mono bg-[#142238] border border-slate-700 text-[#E6B445] px-2 py-0.5 rounded">GUTTER15</span> on your quote.
                Also here for any other service? Grab a free quote while you&apos;re at it.
              </p>

              <div className="mt-5 flex flex-col sm:flex-row gap-3 sm:items-center">
                <button
                  onClick={go}
                  data-testid="gutter-popup-cta"
                  className="group bg-[#E6B445] hover:bg-[#f0c766] text-[#0B1726] font-heading font-black tracking-[0.15em] uppercase text-sm sm:text-base px-6 py-4 rounded-md flex items-center justify-center gap-3 transition-all shadow-[0_10px_30px_-8px_rgba(230,180,69,0.6)]"
                >
                  <Droplets className="w-5 h-5" />
                  Claim 15% Off
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </button>
                <button
                  onClick={dismiss}
                  data-testid="gutter-popup-later"
                  className="text-slate-400 hover:text-white font-heading uppercase text-xs tracking-wider py-3 sm:py-0 transition-colors"
                >
                  No thanks
                </button>
              </div>

              <div className="mt-4 text-[11px] sm:text-xs text-slate-500">
                Offer applies to new gutter cleaning bookings. No spam. No sales calls.
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
